<div
  class="absolute top-0 left-0 -mt-7 h-7 flex items-center justify-center p-1 gap-3 bg-blue-400 rounded-t text-white text-xs font-semibold"
>
  <h3 class="flex items-center justify-center">
    <flx-icon
      name="stars-flowx-yellow"
      class="mr-1"
    />
    <span class="whitespace-nowrap">{{ title() }}</span>
  </h3>

  <div class="flex items-center justify-center pointer-events-auto">
    <!-- TODO: rewire to the AI builder harness
    @if (hasInfoButton()) {
      <button
        (click)="draftInfo()"
        class="w-6 h-5 flex items-center justify-center bg-blue-600 rounded mr-1"
      >
        <i class="ph ph-info text-[16px]"></i>
      </button>
    }
    -->
  </div>
</div>
